import React, { useState, useEffect } from "react";
import "./mobilenav.css";
// img svg

import logo from "../../assets/header/logo.svg";

import searchIcon from "../../assets/header/search.svg";
import mobileMenuClose from "../../assets/header/mobile-menu-close.svg";
import hamburgerIcon from "../../assets/header/hamburger.svg";
import screenReaderOffBlueIcon from "../../assets/header/screen-reader-off-blue.svg";

import screenReaderOffWhiteIcon from "../../assets/header/screen-reader-off-white.svg";
import screenReaderOnWhiteIcon from "../../assets/header/screen-reader-on-white.svg";
import Logo from "../../assets/header/logout.svg";
import screenReaderOnBlueIcon from "../../assets/header/screen-reader-on-blue.svg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleHalfStroke } from "@fortawesome/free-solid-svg-icons";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import MenuMobileOverlay from "../../components/SideBar/SideBarMobile";
import { observer } from "mobx-react";
import General from "../../stores/GeneralStore";
import User from "../../stores/UserStore";
import { NotificationButton } from "../../screens/Tabs.MUI/tabs.styled";
import constants from "../../utils/constants"
import voiceRecognitionIcon from "../../assets/header/search-voice-recognition.svg";


const NavbarMobile = ({
  profileClick,
  handleLogoutClick,
  handleNotification,
}) => {
  const [posts, setPosts] = useState([]);

  const [fontSize, setFontSize] = useState(16);

  const [color, setColor] = useState("");

  const [menu, setMenu] = useState(14);
  const [menu1, setMenu1] = useState(false);
  const [menu2, setMenu2] = useState(false);

  const navigate = useNavigate();

  const [showSearch, setShowSearch] = useState(false);
  const [showLanguageMenu, setShowLanguageMenu] = useState(false);
  const [showSettingsMenu, setShowSettingsMenu] = useState(false);
  const [showUserMenu, setShowUserMenu] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [keyword, setKeyword] = useState("");
  const [selectedColor, setSelectedColor] = useState("#101E8E");
  const [selectedFontSize, setFontSizeSelected] = useState("normal");
  const [reader, setReader] = useState();
  const searchParams = new URLSearchParams(window.location.search)
  const stateParam = searchParams.get('Lang');
  useEffect(() => {
    if(stateParam){
      defaultLanguage(stateParam)
    }
  }, []);
  const defaultLanguage=async(data)=>{
    localStorage.setItem("settingUplanguage", data);
    await General.getCodeLabels();
  }
  const toggleLanguageMenu = () => {
    setShowLanguageMenu(!showLanguageMenu);
    setShowSettingsMenu(false);
    setShowUserMenu(false);
    setShowSearch(false);
  };

  const toggleSettingsMenu = () => {
    setShowSettingsMenu(!showSettingsMenu);
    setShowLanguageMenu(false);
    setShowUserMenu(false);
    setShowSearch(false);
  };

  const toggleUserMenu = () => {
    setShowUserMenu(!showUserMenu);
    setShowSettingsMenu(false);
    setShowLanguageMenu(false);
    setShowSearch(false);
  };
  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };
  const handleInputChange = (event) => {
    setKeyword(event.target.value);
  };
  const addLanguage = async (data) => {
    localStorage.setItem("settingUplanguage", data);
    await General.getCodeLabels();
  };

  const loginRegisterHandler = (link) => {
    window.open(link, "_blank");
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      handleSearch();
    }
  };
  const handleSearch = () => {
    if (keyword.trim() !== "") {
      axios
        .get(
          `${constants.URL.BASE_URL}ASPCL/web/search?keyword=${keyword}&lang=en`
        )
        .then((response) => {
          window.open(
            `${constants.URL.CORPORATE_WEBSITE}searchresults/${keyword}`,
            "_blank"
          );
        })
        .catch((error) => {
          console.error(error);
        });
    }
  };
  const handleClick = (e) => {
    localStorage.setItem("fontSize", `${e}rem`);
    General.handleAccessibility({ text: e, backGround: "" });
  };
  const handleColorClick = (e) => {
    setSelectedColor(e);
    General.handleColorClick({ type: e,colorClass:e=="#62AA51"?"green":e=="#000000"?"black":null,textClass:e=="#62AA51"?"greenText":e=="#000000"?"blackText":null });
  };
  const handleReaderClick = (e) => {
    General.handleScreenReader({ type: e });
  };
  const handleContrastClick = (contrastColor, contrastBackground) => {
    General.handleContrast({ contrastColor, contrastBackground });
  };
  const handleProfile = () => {
    profileClick();
  };
  const ColorAss = General?.ColorAss;
  const contrast = General?.contrast;
  return (
    <div
      className="navbar"
      style={{
       backgroundColor: General.contrast.contrastColor?General.contrast.contrastColor:"#fff"
      }}
    >
      <div className="wrapper">
        <div className="navbar-container">
          <img
            className="logo"
            src={logo}
            onClick={() => navigate("/dashboard")} alt="logo"
          />
          <div style={{ position: "relative" }} className="icons">
            {!User.info.userName && (
              <span onClick={() => {
                setShowSearch((prev) => !prev);
                setShowLanguageMenu(false);
                setShowSettingsMenu(false);
                setShowUserMenu(false);
              }}
    >
                <img src={searchIcon} alt="search" style={{ width: 22, height: 22, marginRight: 12, cursor: "pointer" }} />
              </span>
            )}
            <span onClick={toggleLanguageMenu}>
               <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
               <path fill-rule="evenodd" clip-rule="evenodd" d="M12 0C5.37876 0 0 5.37876 0 12C0 18.6212 5.37876 24 12 24C18.6212 24 24 18.6212 24 12C24 5.37876 18.6212 0 12 0ZM11.4783 1.10462V5.72792H7.74457C7.94165 5.14658 8.16431 4.60616 8.40897 4.11685C9.26758 2.39962 10.3556 1.35425 11.4783 1.10462ZM15.591 4.11685C14.7324 2.39962 13.6444 1.35425 12.5217 1.10462V5.72792H16.2554C16.0583 5.14658 15.8357 4.60616 15.591 4.11685ZM8.96433 1.47147C8.40199 2.06193 7.90056 2.80009 7.47554 3.65014C7.16059 4.28004 6.88759 4.98055 6.65115 5.72792H3.02038C4.43942 3.69874 6.52412 2.17234 8.96433 1.47147ZM20.9796 5.72792C19.5606 3.69874 17.4759 2.17234 15.0357 1.47147C15.598 2.06193 16.0994 2.80009 16.5245 3.65014C16.8394 4.28004 17.1124 4.98055 17.3488 5.72792H20.9796ZM2.35496 6.79382H6.35156C5.99752 8.22255 5.7919 9.80616 5.75442 11.4783H1.05978C1.13906 9.78822 1.59638 8.19792 2.35496 6.79382ZM11.4783 6.79382H7.42867C7.05935 8.19669 6.8389 9.78938 6.79891 11.4783H11.4783V6.79382ZM12.5217 6.79382H16.5713C16.9406 8.19669 17.1611 9.78938 17.2011 11.4783H12.5217V6.79382ZM21.645 6.79382H17.6484C18.0025 8.22255 18.2081 9.80616 18.2456 11.4783H22.9402C22.8609 9.78822 22.4036 8.19792 21.645 6.79382ZM1.06488 12.5217H5.75238C5.78894 14.1954 5.99741 15.777 6.35156 17.2062H2.35598C1.59713 15.8026 1.14426 14.2117 1.06488 12.5217ZM11.4783 12.5217H6.79586C6.8352 14.212 7.0592 15.8027 7.42867 17.2062H11.4783V12.5217ZM12.5217 12.5217H17.2041C17.1648 14.212 16.9408 15.8027 16.5713 17.2062H12.5217V12.5217ZM22.9351 12.5217H18.2476C18.2111 14.1954 18.0026 15.777 17.6484 17.2062H21.644C22.4029 15.8026 22.8557 14.2117 22.9351 12.5217ZM3.02344 18.2721H6.65115C6.88759 19.0195 7.16059 19.72 7.47554 20.3499C7.90056 21.1999 8.40199 21.9381 8.96433 22.5285C6.52496 21.8279 4.44272 20.2995 3.02344 18.2721ZM11.4783 18.2721H7.74457C7.94165 18.8534 8.16431 19.3938 8.40897 19.8832C9.26758 21.6004 10.3556 22.6457 11.4783 22.8954V18.2721ZM12.5217 18.2721H16.2554C16.0583 18.8534 15.8357 19.3938 15.591 19.8832C14.7324 21.6004 13.6444 22.6457 12.5217 22.8954V18.2721ZM20.9766 18.2721H17.3488C17.1124 19.0195 16.8394 19.72 16.5245 20.3499C16.0994 21.1999 15.598 21.9381 15.0357 22.5285C17.475 21.8279 19.5573 20.2995 20.9766 18.2721Z" fill={General?.colorClass?General?.colorClass:"#101E8E"}/>
               </svg>
            </span>
            <span onClick={toggleSettingsMenu} >
               <svg width="17" height="24" viewBox="0 0 17 24" fill="none" xmlns="http://www.w3.org/2000/svg">
               <path fill-rule="evenodd" clip-rule="evenodd" d="M6 3C6 1.34961 7.34961 0 9 0C10.6504 0 12 1.34961 12 3C12 4.65039 10.6504 6 9 6C7.34961 6 6 4.65039 6 3ZM11 3C11 1.88867 10.1113 1 9 1C7.88867 1 7 1.88867 7 3C7 4.11133 7.88867 5 9 5C10.1113 5 11 4.11133 11 3ZM6.82014 6C6.55881 6 6.29564 6.07601 6.05455 6.19764C6.05271 6.19859 6.04995 6.19811 6.04719 6.19764C6.04443 6.19716 6.04167 6.19668 6.03983 6.19764L1.96163 8.08277C1.48314 8.29561 1.21261 8.74219 1.09299 9.17736L0.0476696 12.978C-0.160289 13.7667 0.334763 14.5648 1.09299 14.772C0.430461 15.7278 0.0329469 16.9003 0.0329469 18.1622C0.0329469 21.3813 2.56894 24 5.68648 24C8.04581 24 10.0665 22.4911 10.9131 20.3666L13.8282 23.3767C13.9183 23.4679 14.0416 23.5173 14.1668 23.5135H16.5224C16.6917 23.5154 16.85 23.4242 16.9365 23.2722C17.0212 23.1201 17.0212 22.9339 16.9365 22.7819C16.85 22.6299 16.6917 22.5386 16.5224 22.5405H14.3729L11.2222 19.2872C11.2922 18.9204 11.34 18.5498 11.34 18.1622C11.34 17.8277 11.3032 17.5084 11.2517 17.1892H12.2528L13.7693 20.9139C13.7702 20.9177 13.7734 20.9195 13.7766 20.9214C13.7799 20.9234 13.7831 20.9253 13.784 20.9291C14.0564 21.6759 14.7999 22.1928 15.6096 22.0541L15.6243 22.0389C16.6402 21.8431 17.2346 20.7352 16.8611 19.7432V19.728L14.8882 14.3919C14.8845 14.3824 14.879 14.371 14.8735 14.3615C14.6158 13.761 14.0619 13.2973 13.3718 13.2973H10.2947L10.9131 9.13176C11.1394 7.49367 9.9156 6 8.27769 6H6.82014ZM8.28381 7H6.83526C6.72552 7 6.61578 7.02322 6.48409 7.09286C6.47495 7.09867 6.46397 7.10447 6.45483 7.10834L2.38717 9.04303C2.20793 9.12429 2.10368 9.25585 2.03601 9.50735L1.01178 13.3767C0.949595 13.6186 1.13981 13.9436 1.4361 13.9958H1.45074C1.62449 14.0326 1.89884 13.8217 1.97748 13.547L2.82613 10.436C2.86271 10.2909 2.95964 10.171 3.0895 10.111L6.19145 8.76443C6.34692 8.70059 6.52433 8.73155 6.65419 8.84376C6.78404 8.95403 6.84806 9.13203 6.82062 9.30615L6.33777 12.4945C7.44614 12.6261 8.46122 13.0962 9.27877 13.8101L9.9811 9.05851C10.1311 7.95187 9.37205 7 8.28381 7ZM6 10L5.59239 12.3433C4.66101 12.3899 3.78057 12.6194 3 13L3.65217 10.8657L6 10ZM10 18C10 15.2324 7.99082 13 5.5 13C3.00918 13 1 15.2324 1 18C1 20.7676 3.00918 23 5.5 23C7.99082 23 10 20.7676 10 18ZM10 14H13.3939C13.632 14 13.8898 14.2107 14.0097 14.4839C14.0115 14.4878 14.0142 14.4897 14.0169 14.4917C14.0195 14.4936 14.0222 14.4956 14.024 14.4995L15.9429 19.9779C16.1148 20.4461 15.8857 20.8851 15.4274 20.9924C15.1213 21.0471 14.7472 20.7993 14.6398 20.4774V20.4461L13.0359 16.31C12.9661 16.1188 12.7943 15.9959 12.6063 15.9978H11.1027C10.8592 15.2525 10.4762 14.5775 10 14ZM5 18C5 17.4473 5.44727 17 6 17C6.55273 17 7 17.4473 7 18C7 18.5527 6.55273 19 6 19C5.44727 19 5 18.5527 5 18Z" fill={General?.colorClass?General?.colorClass:"#101E8E"} />
               </svg>
            </span>
            <span  onClick={User.info.personId ? handleProfile : toggleUserMenu}>
             <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                 <g clip-path="url(#clip0_1_54819)">
                 <path d="M11.5 11C12.39 11 13.26 10.7361 14.0001 10.2416C14.7401 9.74715 15.3169 9.04434 15.6575 8.22208C15.998 7.39981 16.0872 6.49501 15.9135 5.62209C15.7399 4.74918 15.3113 3.94736 14.682 3.31802C14.0526 2.68868 13.2508 2.2601 12.3779 2.08647C11.505 1.91283 10.6002 2.00195 9.77792 2.34254C8.95566 2.68314 8.25285 3.25991 7.75839 3.99994C7.26392 4.73996 7 5.60999 7 6.5C7 7.69347 7.47411 8.83807 8.31802 9.68198C9.16193 10.5259 10.3065 11 11.5 11ZM11.5 3.28572C12.1357 3.28572 12.7572 3.47423 13.2858 3.82742C13.8143 4.18061 14.2263 4.68261 14.4696 5.26995C14.7129 5.85728 14.7765 6.50357 14.6525 7.12708C14.5285 7.75059 14.2224 8.32332 13.7728 8.77284C13.3233 9.22237 12.7506 9.5285 12.1271 9.65252C11.5036 9.77655 10.8573 9.71289 10.2699 9.46961C9.68261 9.22633 9.18061 8.81435 8.82742 8.28576C8.47423 7.75718 8.28571 7.13573 8.28571 6.5C8.28571 5.64752 8.62436 4.82995 9.22716 4.22716C9.82995 3.62436 10.6475 3.28572 11.5 3.28572Z" fill={General?.colorClass?General?.colorClass:"#101E8E"}/>
                 <path d="M19.6534 16.4507C18.6049 15.3608 17.3413 14.4926 15.9399 13.8993C14.5386 13.306 13.0289 13 11.5033 13C9.97756 13 8.4679 13.306 7.06656 13.8993C5.66522 14.4926 4.40164 15.3608 3.35308 16.4507C3.12574 16.6895 2.99949 17.0045 3 17.3317V20.714C3 21.055 3.13778 21.3821 3.38301 21.6233C3.62825 21.8645 3.96087 22 4.30769 22H18.6923C19.0391 22 19.3717 21.8645 19.617 21.6233C19.8622 21.3821 20 21.055 20 20.714V17.3317C20.0023 17.0054 19.8784 16.6905 19.6534 16.4507ZM18.6923 20.714H4.30769V17.3252C5.23434 16.3656 6.34984 15.6015 7.5863 15.0793C8.82277 14.5572 10.1543 14.2879 11.5 14.2879C12.8456 14.2879 14.1772 14.5572 15.4137 15.0793C16.6501 15.6015 17.7656 16.3656 18.6923 17.3252V20.714Z" fill={General?.colorClass?General?.colorClass:"#101E8E"}/>
                 </g>
                 <defs>
                 <clipPath id="clip0_1_54819">
                 <rect width="24" height="24" fill="white"/>
                 </clipPath>
                 </defs>
            </svg>
            </span>
            {!User.info.userName && (
              <img src={hamburgerIcon} onClick={toggleMenu} />
            )}
            {User.info.personId && (
              <span
                style={{ position: "relative" }}
                onClick={handleNotification}
              >
                <svg width="20" height="24" viewBox="0 0 20 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                   <path fill-rule="evenodd" clip-rule="evenodd" d="M8.09524 1.92C8.09524 0.864375 8.95275 0 10 0C11.0472 0 11.9048 0.864375 11.9048 1.92C11.9048 2.1675 11.8564 2.4075 11.7708 2.625C14.4457 3.33 16.1905 5.67375 16.1905 8.64C16.1905 12.3994 17.1057 14.1112 17.9762 15.075C18.3563 15.4958 18.7321 15.7722 19.0678 16.019L19.0678 16.019C19.1165 16.0548 19.1644 16.0901 19.2113 16.125C19.3973 16.2619 19.5666 16.3988 19.7173 16.575C19.8679 16.7512 20 17.0025 20 17.28C20 17.94 19.5982 18.5006 19.0327 18.87C18.4673 19.2394 17.7251 19.4775 16.8304 19.665C15.6696 19.9069 14.2374 20.0344 12.6637 20.1C12.7846 20.4169 12.8571 20.76 12.8571 21.12C12.8571 22.7044 11.5718 24 10 24C8.4282 24 7.14286 22.7044 7.14286 21.12C7.14286 20.7619 7.21726 20.4188 7.33631 20.1C5.76265 20.0344 4.33036 19.9069 3.16964 19.665C2.27493 19.4775 1.53274 19.2394 0.967262 18.87C0.401786 18.5006 0 17.94 0 17.28C0 17.0025 0.132069 16.7512 0.282738 16.575C0.433408 16.3988 0.602679 16.2619 0.788691 16.125C0.835617 16.0901 0.8835 16.0548 0.932229 16.019C1.26789 15.7722 1.64372 15.4958 2.02381 15.075C2.89435 14.1112 3.80952 12.3994 3.80952 8.64C3.80952 5.67188 5.5506 3.32625 8.22917 2.625C8.1436 2.4075 8.09524 2.1675 8.09524 1.92ZM10.9524 1.9201C10.9524 1.38385 10.532 0.9601 9.99999 0.9601C9.46799 0.9601 9.04761 1.38385 9.04761 1.9201C9.04761 2.45635 9.46799 2.8801 9.99999 2.8801C10.532 2.8801 10.9524 2.45635 10.9524 1.9201ZM11.1161 3.44992C13.6551 3.90554 15.2381 5.88367 15.2381 8.63992C15.2381 12.5605 16.2277 14.5743 17.2619 15.7199C17.7209 16.2275 18.1843 16.5667 18.5233 16.8149L18.5235 16.815C18.5663 16.8464 18.6072 16.8763 18.6458 16.9049C18.8169 17.0324 18.9453 17.1393 19.003 17.2049C19.051 17.2596 19.05 17.2648 19.0483 17.2737C19.048 17.2755 19.0476 17.2774 19.0476 17.2799C19.0476 17.5799 18.91 17.7993 18.5119 18.0599C18.1138 18.3205 17.4665 18.5624 16.6369 18.7349C14.9777 19.0818 12.6153 19.1999 9.99998 19.1999C7.38465 19.1999 5.0223 19.0818 3.36308 18.7349C2.53346 18.5624 1.88614 18.3205 1.48808 18.0599C1.09001 17.7993 0.952362 17.5799 0.952362 17.2799C0.952362 17.2774 0.951998 17.2755 0.951661 17.2737C0.949984 17.2648 0.948994 17.2596 0.997005 17.2049C1.05467 17.1393 1.18302 17.0324 1.35415 16.9049C1.39276 16.8763 1.43361 16.8464 1.47646 16.815L1.47671 16.8149C1.81571 16.5667 2.27909 16.2275 2.73808 15.7199C3.7723 14.5743 4.76189 12.5605 4.76189 8.63992C4.76189 5.88554 6.34671 3.92242 8.88391 3.46492C9.20013 3.69929 9.58146 3.83992 9.99998 3.83992C10.4222 3.83992 10.7998 3.68804 11.1161 3.44992ZM8.80583 20.1403C8.65745 20.1366 8.50993 20.133 8.36311 20.1299C8.19012 20.4186 8.09525 20.7561 8.09525 21.1199C8.09525 22.1868 8.9416 23.0399 10 23.0399C11.0584 23.0399 11.9048 22.1868 11.9048 21.1199C11.9048 20.7599 11.8062 20.4186 11.6369 20.1299C11.4901 20.133 11.3426 20.1366 11.1942 20.1403C10.803 20.15 10.4059 20.1599 10 20.1599C9.5941 20.1599 9.19698 20.15 8.80583 20.1403Z" fill={General?.colorClass?General?.colorClass:"#101E8E"}/>
                </svg>

                <div
                  style={{
                    position: "absolute",
                    top: "-3px",
                    left: "8px",
                    background:General?.colorClass?General?.colorClass: "#62aa51",
                    color: "#fff",
                    borderRadius: "50%",
                    height: "15px",
                    width: "15px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    fontSize: "10px",
                  }}
                >
                  {General.notifications.count}
                </div>
              </span>
            )}
            {User.info.userName && (
              <span  onClick={handleLogoutClick}>
                <svg width="20" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M11 12V0H13V12H11ZM0 12C0 6.78516 3.34766 2.33984 8 0.6875V2.84375C4.47266 4.39062 2 7.91016 2 12C2 17.5156 6.48438 22 12 22C17.5156 22 22 17.5156 22 12C22 7.91016 19.5273 4.39062 16 2.84375V0.6875C20.6523 2.33984 24 6.78516 24 12C24 18.6172 18.6172 24 12 24C5.38281 24 0 18.6172 0 12Z" fill={General?.colorClass?General?.colorClass:"#101E8E"}/>
              </svg>

              </span>
            )}
          </div>
        </div>
        </div>

              {!User.info.userName && showSearch && (
          <div
            className={`search-bar-mobile ${
              General?.colorClass === "black"
                ? "search-bar-black"
                : General?.colorClass === "green"
                ? "search-bar-green"
                : ""
            }${General.contrast.contrastColor ? General.contrast.contrastColor === 'yellow' ? 'search-bar-yellowContrast' : 'search-bar-blackContrast' : ""}`}
            style={{
              backgroundColor: General.contrast.contrastBackground
                ? General.contrast.contrastBackground
                : "#fff",
              padding: "0.5rem 1rem",
              display: "flex",
              alignItems: "center",
              borderRadius: "8px",
              margin: "1rem 0",
              width:"100%"
            }}
          >
            <img
              src={voiceRecognitionIcon}
              className="voice-icon"
              alt="voice"
              style={{ width: 24, height: 24, marginRight: 8, cursor: "pointer" }}
            />
            <input
              type="text"
              className="input-field"
              placeholder="Search"
              onChange={handleInputChange}
              value={keyword}
              onKeyDown={handleKeyDown}
              style={{
                flex: 1,
                border: "none",
                outline: "none",
                fontSize: 16,
                background: "transparent",
              }}
              autoFocus
            />
            <img
              src={searchIcon}
              className="search-icon"
              onClick={handleSearch}
              alt="search"
              style={{ width: 22, height: 22, marginLeft: 8, cursor: "pointer" }}
            />
            <img
              src={mobileMenuClose}
              onClick={() => setShowSearch(false)}
              alt="close"
              style={{ width: 22, height: 22, marginLeft: 8, cursor: "pointer" }}
            />
          </div>
        )}

      {showLanguageMenu && (
        <div
          className="navbar-language-changer-menu"
          style={{
            marginTop: User.info.userName ? "-2rem" : "",
            background: contrast?.contrastBackground? contrast?.contrastBackground : selectedColor,
          }}
        >
          <img
            className="close-icon"
            src={mobileMenuClose}
            onClick={toggleLanguageMenu}
          />
          <div className="menu">
            <div
              style={{
                color: "",
              }}
              className="en"
              onClick={() => addLanguage("en-US")}
            >
              {(General?.codeLabels["cm_eng"]?.label !== undefined
                ? General?.codeLabels["cm_eng"]?.label
                : "English").toUpperCase()}
            </div>
            <div
              style={{
                color: "",
              }}
              className="ar"
              onClick={() => addLanguage("ar")}
            >
              {General?.codeLabels["cm_ar"]?.label !== undefined
                ? General?.codeLabels["cm_ar"]?.label
                : "Arabic"}
            </div>
            <div
              style={{
                color: "",
              }}
              className="hi"
              onClick={() => addLanguage("hi")}
            >
              {(General?.codeLabels["cm_hin"]?.label !== undefined
                ? General?.codeLabels["cm_hin"]?.label
                : "Hindi").toUpperCase()}
            </div>
          </div>
        </div>
      )}

      {showSettingsMenu && (
        <div
          className="navbar-settings-menu"
          style={{
            marginTop: User.info.userName ? "-2rem" : "",
            background: contrast?.contrastBackground? contrast?.contrastBackground : selectedColor,
            zIndex: 9999,
          }}
        >
          <img
            className="close-icon"
            src={mobileMenuClose}
            onClick={toggleSettingsMenu}
          />

          <div className="menu">
            <div className="customizer">
              <div
                className="title"
                style={{
                  fontSize: `${
                    fontSize === 1
                      ? "10px"
                      : fontSize === 2
                      ? "12px"
                      : fontSize === 3
                      ? "14px"
                      : fontSize === 4
                      ? "16px"
                      : fontSize === 5
                      ? "18px"
                      : "14px"
                  }`,
                }}
              >
                {General?.codeLabels["cm_text_size"]?.label !== undefined
                  ? General?.codeLabels["cm_text_size"]?.label
                  : "TEXT SIZE"}
              </div>
              <div className="fontsize-btns">
                <div
                  onClick={() => {
                    setFontSize(1);
                    setFontSizeSelected("small");
                    handleClick(0.75);
                  }}
                  className={selectedFontSize === "small" ? "selected" : ""}
                >
                  A--
                </div>
                <div
                  onClick={() => {
                    setFontSize(2);
                    handleClick(0.85);
                    setFontSizeSelected("medium");
                  }}
                  className={selectedFontSize === "medium" ? "selected" : ""}
                >
                  A-
                </div>
                <div
                  onClick={() => {
                    setFontSize(3);
                    handleClick(1);
                    setFontSizeSelected("normal");
                  }}
                  className={selectedFontSize === "normal" ? "selected" : ""}
                >
                  A
                </div>
                <div
                  onClick={() => {
                    setFontSize(4);
                    handleClick(1.05);
                    setFontSizeSelected("large");
                  }}
                  className={selectedFontSize === "large" ? "selected" : ""}
                >
                  A+
                </div>
                <div
                  onClick={() => {
                    setFontSize(5);
                    handleClick(1.1);
                    setFontSizeSelected("extra-large");
                  }}
                  className={
                    selectedFontSize === "extra-large" ? "selected" : ""
                  }
                >
                  A++
                </div>
              </div>

              <div
                className="title"
                style={{
                  fontSize: `${
                    fontSize === 1
                      ? "10px"
                      : fontSize === 2
                      ? "12px"
                      : fontSize === 3
                      ? "14px"
                      : fontSize === 4
                      ? "16px"
                      : fontSize === 5
                      ? "18px"
                      : "14px"
                  }`,
                }}
              >
                {General?.codeLabels["cm_color"]?.label !== undefined
                  ? General?.codeLabels["cm_color"]?.label
                  : "COLOR"}
              </div>
              <div className="background-changer-btns">
                          <div
                            onClick={() => handleColorClick("#101E8E")}
                            className={`${selectedColor === "#101E8E"? "selected": "blue"}`}
                          ></div>
                          <div
                            onClick={() => handleColorClick("#000000")}
                            className={`${selectedColor === "#000000"? "selectedBlack": "black"}`}
                          ></div>
                          <div
                            onClick={() => handleColorClick("#62AA51")}
                            className={`${selectedColor === "#62AA51"? "selectedGreen": "green"}`}
                          ></div>
                        </div>
              <div
                className="title"
                style={{
                  color: "",
                  fontSize: `${
                    fontSize === 1
                      ? "10px"
                      : fontSize === 2
                      ? "12px"
                      : fontSize === 3
                      ? "14px"
                      : fontSize === 4
                      ? "16px"
                      : fontSize === 5
                      ? "18px"
                      : "14px"
                  }`,
                }}
              >
                {General?.codeLabels["cm_reader"]?.label !== undefined
                  ? General?.codeLabels["cm_reader"]?.label
                  : "READER"}
              </div>
              <div className="screen-reader">
                <div
                  onClick={() => {
                    setReader("1");
                    handleReaderClick(false);
                  }}
                  className={reader === "1" ? "selected" : ""}
                >
                  <img
                    src={
                      reader === "1"
                        ? screenReaderOffWhiteIcon
                        : screenReaderOffBlueIcon
                    }
                    alt="off"
                  />
                  OFF
                </div>
                <div
                  onClick={() => {
                    setReader("2");
                    handleReaderClick(true);
                  }}
                  className={reader === "2" ? "selected" : ""}
                >
                  <img
                    src={
                      reader === "1"
                        ? screenReaderOnWhiteIcon
                        : screenReaderOnBlueIcon
                    }
                    alt="on"
                  />
                  ON
                </div>
              </div>

              <div
                className="title"
                style={{
                  color: "",
                  fontSize: `${
                    fontSize === 1
                      ? "10px"
                      : fontSize === 2
                      ? "12px"
                      : fontSize === 3
                      ? "14px"
                      : fontSize === 4
                      ? "16px"
                      : fontSize === 5
                      ? "18px"
                      : "14px"
                  }`,
                }}
              >
                {General?.codeLabels["cm_contrast"]?.label !== undefined
                  ? General?.codeLabels["cm_contrast"]?.label
                  : "COLOR CONTRAST"}
              </div>
              <div className="contrast">
                <div className="default-cont">
                  <FontAwesomeIcon
                    icon={faCircleHalfStroke}
                    style={{ color: "" }}
                    onClick={() => handleContrastClick("", "")}
                  />
                </div>
                <div className="yellow-cont">
                  <FontAwesomeIcon
                    icon={faCircleHalfStroke}
                    style={{ color: "#ff0" }}
                    onClick={() => handleContrastClick("yellow", "blue")}
                  />
                </div>
                <div className="green-cont">
                  <FontAwesomeIcon
                    icon={faCircleHalfStroke}
                    style={{ color: "lime" }}
                    onClick={() => handleContrastClick("lime", "black")}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {showUserMenu && (
        <div
          className="navbar-user-menu"
          style={{
            marginTop: User.info.userName ? "-2rem" : "",
            backgroundColor: "",
          }}
        >
          <img
            className="close-icon"
            src={mobileMenuClose}
            onClick={toggleUserMenu}
          />
          <div className="menu">
            <div
              className="tenant-owner"
              onClick={() => navigate("/")}
              style={{
                color: "",
                fontSize: `${
                  fontSize === 1
                    ? "10px"
                    : fontSize === 2
                    ? "12px"
                    : fontSize === 3
                    ? "14px"
                    : fontSize === 4
                    ? "16px"
                    : fontSize === 5
                    ? "18px"
                    : "14px"
                }`,
              }}
            >
              {(General?.codeLabels["cm_login_tenant"]?.label !== undefined
                ? General?.codeLabels["cm_login_tenant"]?.label
                : "Login as a Tenant / Owner").toUpperCase()}
            </div>
            <div
              className="consultant"
              onClick={() =>
                loginRegisterHandler(
                  `${constants.URL.CUSTOMER_PORTAL}`
                )
              }
              style={{
                color: "",
                fontSize: `${
                  fontSize === 1
                    ? "10px"
                    : fontSize === 2
                    ? "12px"
                    : fontSize === 3
                    ? "14px"
                    : fontSize === 4
                    ? "16px"
                    : fontSize === 5
                    ? "18px"
                    : "14px"
                }`,
              }}
            >
              {(General?.codeLabels["cm_login_consultant"]?.label !== undefined
                ? General?.codeLabels["cm_login_consultant"]?.label
                : "Login as a Consultant").toUpperCase()}
            </div>
            <div
              className="new-account"
              onClick={() => navigate("/movein-registration")}
              style={{
                color: "",
                fontSize: `${
                  fontSize === 1
                    ? "10px"
                    : fontSize === 2
                    ? "12px"
                    : fontSize === 3
                    ? "14px"
                    : fontSize === 4
                    ? "16px"
                    : fontSize === 5
                    ? "18px"
                    : "14px"
                }`,
              }}
            >
              {(General?.codeLabels["cm_new_account"]?.label !== undefined
                ? General?.codeLabels["cm_new_account"]?.label
                : "Create New Account").toUpperCase()}
            </div>
          </div>
        </div>
      )}

      {menuOpen && <MenuMobileOverlay toggleMenu={toggleMenu} />}
    </div>
  );
};

export default observer(NavbarMobile);
